import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {HasAnyAuthorityDirective} from './auth/has-any-authority.directive';
import {JhiLoginModalComponent} from './login/login.component';
import {TranslateModule} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {IFrameComponent, SafePipe} from './i-frame/i-frame.component';
import {NewlineToBrPipe} from './newline-to-br/newline-to-br.pipe';

@NgModule({
    imports: [
        TranslateModule,
        ReactiveFormsModule,
        CommonModule
    ],
    declarations: [JhiLoginModalComponent, HasAnyAuthorityDirective, SafePipe, IFrameComponent, NewlineToBrPipe],
    exports: [HasAnyAuthorityDirective, JhiLoginModalComponent, SafePipe, IFrameComponent, NewlineToBrPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DataportalcmsSharedModule {
    static forRoot(): ModuleWithProviders<DataportalcmsSharedModule> {
        return {
            ngModule: DataportalcmsSharedModule
        };
    }
}
